import { render } from "./FormRelOne.vue?vue&type=template&id=2abf6fbe"
import script from "./FormRelOne.vue?vue&type=script&lang=js"
export * from "./FormRelOne.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelOne.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2abf6fbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2abf6fbe', __exports__)) {
    console.log('reload')
    api.reload('2abf6fbe', __exports__)
  }
  
  module.hot.accept("./FormRelOne.vue?vue&type=template&id=2abf6fbe", () => {
    console.log('re-render')
    api.rerender('2abf6fbe', render)
  })

}


export default __exports__